<template>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :effect="'fade'"
    :fade-effect="{ crossFade: true }"
    :looped-slides="list.length"
    :space-between="0"
    :speed="3000"
    :loop="true"
    :autoplay="{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: false }"
    :allowTouchMove="false" 
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <img :src="item.pic" alt="photo">
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
img{
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay,EffectFade } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const breakpoints = {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
      769: {
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
    };

    const onSwiper = (swiper) => {

    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade],
      breakpoints,
    }
  },
}
</script>
